/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import { EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, Modal, Popconfirm, Result, Row, Table, Tag, } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { useDispatch, useSelector } from 'react-redux';
import colorsDark from '../../assets/colors/dark';
import iconEditActive from '../../assets/icons/icon-edit-active.svg';
import iconEdit from '../../assets/icons/icon-edit.svg';
import left from '../../assets/icons/left.svg';
import nextPage from '../../assets/icons/next_page.svg';
import FormCustom from '../../components/FormCustom';
import LogEventServiceCamera from '../../components/LogEventSeriveCamera';
import * as SERVICE from '../../constants/service.types';
import regex from '../../constants/system.keys';
import { deleteListNotification, socketEmitEvent } from '../../redux/actions';

const { confirm } = Modal;
const { Search } = Input;
const LIST_SERVICES_SHOULD_APPEND_SHORT_TOKEN = [52];

const DetailServiceComponent = ({ service: data, setType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [, forceUpdate] = useState();
  const { shortTokenData } = useSelector((state) => state);
  console.log('ShortToken Data: ', shortTokenData);

  const [timeRequest, setTimeRequest] = useState(new Date().getTime());
  const [activateChain, setActivateChain] = useState([]);
  const [activateChainAccount, setActivateChainAccount] = useState([]);
  const [syncLoading, setSyncLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [initialPerNameSpace, setInitialPerNameSpace] = useState({});
  const [initialPerDevice, setInitialPerDevice] = useState({});
  const [initialPerAccount, setInitialPerAccount] = useState({});
  const [checkUpdatePerNamespace, setCheckUpdatePerNamespace] = useState(true);
  const [checkUpdatePerDevice, setCheckUpdatePerDevice] = useState(true);
  const [checkUpdatePerAccount, setCheckUpdatePerAccount] = useState(true);
  const [devices, setDevices] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [devicesActive, setDevicesActive] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [accounts, setAccounts] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [dataNamespace, setDataNamespace] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [accountsActive, setAccountsActive] = useState({
    data: [],
    pagination: {},
    loading: false,
  });

  const [form] = Form.useForm();
  const [formExpand] = Form.useForm();
  const [formExpandAccount] = Form.useForm();

  const {
    isAuth,
    targetsOfServices,
    targetActiveOfServices,
    configurationService,
  } = useSelector((state) => state);
  const { checkLicense, activeLicense, namespace, listNotificationService } =
    useSelector((state) => state);

  const [checkLicenseReturn, setCheckLicenseReturn] = useState();
  const [activeLicenseReturn, setActiveLicenseReturn] = useState();
  const [isLoadCheckLicense, setIsLoadCheckLicense] = useState(false);
  const [isLoadActiveLicense, setIsLoadActiveLicense] = useState([]);
  const [isLoadActiveLicenseAccount, setIsLoadActiveLicenseAccount] = useState(
    []
  );
  const [isLoadActiveLicenseNamespace, setIsLoadActiveLicenseNamespace] =
    useState([]);
  const [license, setLicense] = useState();
  const [licenseInfo, setLicenseInfo] = useState();
  const [expKeys, setExpKeys] = useState([]);
  const [expKeysAccount, setExpKeysAccount] = useState([]);
  const [keyTable, setKeyTable] = useState(Math.random());
  const [dataPerNameTemp, setDataPerNameTemp] = useState({});
  const [dataPerAccountTemp, setDataPerAccountTemp] = useState({});
  const [service, setService] = useState();
  const [dataSearchDeviceByName, setDataSearchDeviceByName] = useState();
  const [dataNotificationEvent, setDataNotificationEvent] = useState([
    'sms',
    'email',
    'call',
  ]);
  const [dataSelectNotificationEvent, setDataSelectNotificationEvent] =
    useState();

  useEffect(() => {
    forceUpdate({});
    form.resetFields();
  }, [form]);

  useEffect(() => {
    if (data) {
      let dataServiceTemp = { ...data };
      let dataPerNamespaceTemp = data?.configuration
        ? { ...data?.configuration }
        : {};
      if (data?.configuration?.timeUpload?.length) {
        const dataTimeUpload = data?.configuration?.timeUpload;
        const dataTemp =
          dataTimeUpload?.map((item) => ({
            rangeTime: [
              moment
                .utc()
                .hours(`${Math.floor(item?.fromTime / 60)}`)
                .minutes(
                  `${item?.fromTime - Math.floor(item?.fromTime / 60) * 60}`
                ),
              moment
                .utc()
                .hours(`${Math.floor(item?.toTime / 60)}`)
                .minutes(
                  `${item?.toTime - Math.floor(item?.toTime / 60) * 60}`
                ),
            ],
          })) || [];
        dataServiceTemp = {
          ...data,
          configuration: {
            ...data.configuration,
            timeUpload: dataTemp,
          },
        };
        dataPerNamespaceTemp = {
          ...dataPerNamespaceTemp,
          timeUpload: dataTemp,
        };
      }
      setService(dataServiceTemp);
      dispatch(deleteListNotification(null));
      if (data?.configuration?.notificationEvent) {
        setDataSelectNotificationEvent(data?.configuration?.notificationEvent);
      }
      setDataPerNameTemp(dataPerNamespaceTemp);
      setDataPerAccountTemp(
        data?.perAccount ? JSON.parse(data?.perAccount) : {}
      );
      setCheckLicenseReturn(null);
      const dataPerNameSpace =
        data?.configurationInput &&
        JSON.parse(data?.configurationInput)?.perNamespace;
      const dataPerDevice =
        data?.configurationInput &&
        JSON.parse(data?.configurationInput)?.perDevice;
      const dataPerAccount =
        data?.configurationInput &&
        JSON.parse(data?.configurationInput)?.perAccount;
      let data1 = {};
      dataPerNameSpace?.map((item) => {
        if (item.type === 'period-minute') {
          data1 = {
            ...data1,
            [item.field]:
              item.defaultValue?.map((item) => ({
                rangeTime: [
                  moment
                    .utc()
                    .hours(`${Math.floor(item?.fromTime / 60)}`)
                    .minutes(
                      `${item?.fromTime - Math.floor(item?.fromTime / 60) * 60}`
                    ),
                  moment
                    .utc()
                    .hours(`${Math.floor(item?.toTime / 60)}`)
                    .minutes(
                      `${item?.toTime - Math.floor(item?.toTime / 60) * 60}`
                    ),
                ],
              })) || [],
          };
        } else {
          data1 = {
            ...data1,
            [item.field]: item.defaultValue,
          };
        }
      });
      let data2 = {};
      dataPerDevice?.map((item) => {
        if (item.type === 'period-minute') {
          data2 = {
            ...data2,
            [item.field]:
              item.defaultValue?.map((item) => ({
                rangeTime: [
                  moment
                    .utc()
                    .hours(`${Math.floor(item?.fromTime / 60)}`)
                    .minutes(
                      `${item?.fromTime - Math.floor(item?.fromTime / 60) * 60}`
                    ),
                  moment
                    .utc()
                    .hours(`${Math.floor(item?.toTime / 60)}`)
                    .minutes(
                      `${item?.toTime - Math.floor(item?.toTime / 60) * 60}`
                    ),
                ],
              })) || [],
          };
        } else {
          data2 = {
            ...data2,
            [item.field]: item.defaultValue,
          };
        }
      });
      let data3 = {};
      dataPerAccount?.map((item) => {
        if (item.type === 'period-minute') {
          data3 = {
            ...data3,
            [item.field]:
              item.defaultValue?.map((item) => ({
                rangeTime: [
                  moment
                    .utc()
                    .hours(`${Math.floor(item?.fromTime / 60)}`)
                    .minutes(
                      `${item?.fromTime - Math.floor(item?.fromTime / 60) * 60}`
                    ),
                  moment
                    .utc()
                    .hours(`${Math.floor(item?.toTime / 60)}`)
                    .minutes(
                      `${item?.toTime - Math.floor(item?.toTime / 60) * 60}`
                    ),
                ],
              })) || [],
          };
        } else {
          data3 = {
            ...data3,
            [item.field]: item.defaultValue,
          };
        }
      });
      setInitialPerNameSpace(data1);
      setInitialPerDevice(data2);
      setInitialPerAccount(data3);
    }
  }, [data]);

  useEffect(() => {
    if (checkLicense && checkLicense.requestId === timeRequest) {
      setCheckLicenseReturn(checkLicense);
    }
  }, [checkLicense]);

  useEffect(() => {
    if (activeLicense) {
      setActiveLicenseReturn(activeLicense);
    }
    return () => {
      setActiveLicenseReturn(null);
    };
  }, [activeLicense]);

  const onPerDevices = useCallback(() => {
    if (service) {
      let data = {
        serviceId: service.id,
        timeRequest,
        page: 0,
        size: 10,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, namespace, service, timeRequest]);

  const onPerNamespace = useCallback(() => {
    let data = {
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_SERVICE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  }, [dispatch, namespace]);

  useEffect(() => {
    if (
      configurationService?.perNamespace &&
      JSON.parse(configurationService?.perNamespace)
    ) {
      onPerNamespace();
    } else if (
      configurationService?.perDevices &&
      JSON.parse(configurationService?.perDevices)?.length > 0
    ) {
      onPerDevices();
    } else if (configurationService?.result === -8) {
      setCheckUpdatePerAccount(false);
    }
  }, [configurationService, onPerDevices, onPerNamespace]);

  useEffect(() => {
    if (
      service &&
      (service.activeType?.includes('per_device') ||
        service.activeType?.includes('per_account') ||
        service.activeType?.includes('per_namespace')) &&
      service.id
    ) {
      setLicense(null);
      form.resetFields();
      if (service.activeType?.includes('per_device')) {
        setDevices((state) => ({ ...state, loading: true }));
      }
      if (service.activeType?.includes('per_account')) {
        setAccounts((state) => ({ ...state, loading: true }));
      }
      if (service.activeType?.includes('per_namespace')) {
        setDataNamespace((state) => ({ ...state, loading: true }));
      }
      let data = {
        serviceId: service.id,
        timeRequest,
        page: 0,
        size: 10,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_TARGET_BY_SERVICE_ID,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, form, namespace, service]);

  useEffect(() => {
    if (
      service &&
      (service.activeType?.includes('per_device') ||
        service.activeType?.includes('per_account')) &&
      service.id
    ) {
      setLicense(null);
      let data = {
        serviceId: service.id,
        timeRequest,
        page: 0,
        size: 10,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, form, namespace, service]);

  useEffect(() => {
    if (
      service &&
      targetsOfServices &&
      service.id === targetsOfServices.serviceId
    ) {
      if (service.activeType?.includes('per_device')) {
        setDevices((state) => ({
          data: targetsOfServices.perDevice,
          pagination: {
            ...state.pagination,
            total: targetsOfServices.total,
          },
          loading: false,
        }));
      }
      if (service.activeType?.includes('per_account')) {
        setAccounts((state) => ({
          data: targetsOfServices.perAccount,
          pagination: {
            ...state.pagination,
            total: targetsOfServices.total,
          },
          loading: false,
        }));
      }
      if (service.activeType?.includes('per_namespace')) {
        setDataNamespace((state) => ({
          ...state,
          data: [
            {
              namespace: service.name,
              id: service.id,
              key: service.id,
              active: targetsOfServices.perNamespace ? true : false,
            },
          ],
          loading: false,
        }));
      }
    }
  }, [targetsOfServices, service]);

  useEffect(() => {
    if (
      service &&
      targetActiveOfServices &&
      service.id === targetActiveOfServices.serviceId
    ) {
      if (targetActiveOfServices.perDevice?.length) {
        setDevicesActive((state) => ({
          data: targetActiveOfServices.perDevice,
          pagination: {
            ...state.pagination,
            total: targetActiveOfServices.total,
          },
          loading: false,
        }));
      }
      if (targetActiveOfServices.perAccount?.length) {
        setAccountsActive((state) => ({
          data: targetActiveOfServices.perAccount,
          pagination: {
            ...state.pagination,
            total: targetActiveOfServices.total,
          },
          loading: false,
        }));
      }
    }
  }, [targetActiveOfServices, service]);

  const handleTableChange = useCallback(
    (pagination, _, sort) => {
      if (service) {
        const { field, order } = sort;
        if (service.activeType?.includes('per_device')) {
          setDevices((state) => ({
            ...state,
            pagination: {
              ...state.pagination,
              current: pagination.current,
              pageSize: pagination.pageSize,
            },
            loading: true,
          }));
        }

        if (service.activeType?.includes('per_account')) {
          setAccounts((state) => ({
            ...state,
            pagination: {
              ...state.pagination,
              current: pagination.current,
              pageSize: pagination.pageSize,
            },
            loading: true,
          }));
        }

        let data = {
          serviceId: service.id,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
          namespace,
          field,
          order,
        };
        if (dataSearchDeviceByName) {
          data.subName = dataSearchDeviceByName;
        }
        let dataObj = {
          appServiceType: SERVICE.LIST_TARGET_BY_SERVICE_ID,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },

    [dispatch, namespace, service, timeRequest, dataSearchDeviceByName]
  );

  const handleTableChangeActive = useCallback(
    (pagination, _, sort) => {
      if (service) {
        const { field, order } = sort;
        setDevicesActive((state) => ({
          ...state,
          pagination: {
            ...state.pagination,
            current: pagination.current,
          },
          loading: true,
        }));

        let data = {
          serviceId: service.id,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
          namespace,
          field,
          order,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },

    [dispatch, namespace, service, timeRequest]
  );

  const handleTableChangeAccountActive = useCallback(
    (pagination, _, sort) => {
      if (service) {
        const { field, order } = sort;
        setAccountsActive((state) => ({
          ...state,
          pagination: {
            ...state.pagination,
            current: pagination.current,
          },
          loading: true,
        }));

        let data = {
          serviceId: service.id,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
          namespace,
          field,
          order,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },

    [dispatch, namespace, service, timeRequest]
  );

  const rowSelection = {
    getCheckboxProps: (record) => ({
      disabled: !(license && !record.service),
      key: record.serial,
    }),
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys, rows) =>
      setActivateChain(
        rows.map((device) => ({ name: device.name, serial: device.serial }))
      ),
  };

  const rowSelectionAccount = {
    getCheckboxProps: (record) => ({
      disabled: !(license && !record.service),
      key: record.accountId,
    }),
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys, rows) =>
      setActivateChainAccount(
        rows.map((account) => ({
          fullname: account.fullname,
          accountId: account.accountId,
        }))
      ),
  };

  useEffect(() => {
    if (checkLicenseReturn) {
      setIsLoadCheckLicense(false);
      if (checkLicenseReturn.result === -13) {
        form.setFields([
          {
            name: 'checkCode',
            errors: [t('Invalid license!')],
          },
        ]);
        setLicenseInfo(null);
      } else if (checkLicenseReturn.data) {
        const { size, numberActive, endAt, licenseCode, serviceId } =
          JSON.parse(checkLicenseReturn.data);
        if (service && serviceId !== service.id) {
          form.setFields([
            {
              name: 'checkCode',
              errors: [t('License not found')],
            },
          ]);
          setLicenseInfo(null);
        } else if (new Date().getTime() > new Date(endAt).getTime()) {
          form.setFields([
            {
              name: 'checkCode',
              errors: [t('License expired')],
            },
          ]);
          setLicenseInfo({
            ...JSON.parse(checkLicenseReturn.data),
          });
        } else if (numberActive >= size) {
          form.setFields([
            {
              name: 'checkCode',
              errors: [t('The license has used up its activation turn!')],
            },
          ]);
          setLicenseInfo({
            ...JSON.parse(checkLicenseReturn.data),
          });
        } else {
          setLicense({
            licenseCode: licenseCode,
            size: size,
            numberActive: numberActive,
          });
          setLicenseInfo({
            ...JSON.parse(checkLicenseReturn.data),
          });
        }
      }
    }
    return () => {
      setLicense(null);
    };
  }, [checkLicenseReturn, form, service, t]);

  useEffect(() => {
    if (activeLicenseReturn) {
      setInterval(() => {
        if (service.activeType?.includes('per_device')) {
          setIsLoadActiveLicense((state) =>
            state.filter((serial) => serial !== deviceSerial)
          );
        }
        if (service.activeType?.includes('per_account')) {
          setIsLoadActiveLicenseAccount((state) =>
            state.filter((id) => id !== accountId)
          );
        }
        if (service.activeType?.includes('per_namespace')) {
          setIsLoadActiveLicenseNamespace((state) =>
            state.filter((id) => id !== service?.id)
          );
        }
      }, 2000);
      const { result, data } = activeLicenseReturn;
      const { licenseCode, endAt, startAt, deviceSerial, accountId } =
        JSON.parse(data);
      if (result === 1) {
        setLicense((state) => ({
          ...state,
          numberActive: state?.numberActive + 1,
        }));
        if (service.activeType?.includes('per_device')) {
          setDevices((state) => ({
            ...state,
            data: state.data.map((device) =>
              device.serial === deviceSerial
                ? {
                  ...device,
                  service: {
                    licenseCode,
                    endAt,
                    startAt,
                  },
                }
                : device
            ),
          }));
        }
        if (service.activeType?.includes('per_account')) {
          setAccounts((state) => ({
            ...state,
            data: state.data.map((account) =>
              account.accountId === accountId
                ? {
                  ...account,
                  service: {
                    licenseCode,
                    endAt,
                    startAt,
                  },
                }
                : account
            ),
          }));
        }
        if (service.activeType?.includes('per_namespace')) {
          setDataNamespace((state) => ({
            ...state,
            data: [
              {
                namespace: service.name,
                id: service.id,
                key: service.id,
                active: true,
              },
            ],
            loading: false,
          }));
        }
      } else {
      }
    }
  }, [activeLicenseReturn]);

  const onCheckCode = useCallback(
    (licenseCode) => {
      setIsLoadCheckLicense(true);
      if (isAuth && licenseCode) {
        let data = {
          licenseCode,
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.GET_LICENSE_INFO_SERVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, namespace]
  );

  const onFinishPerNamespace = useCallback(
    (value) => {
      if (value && service) {
        let dataNotifocation;
        listNotificationService?.eventInfos?.map((item) => {
          dataNotifocation = {
            ...dataNotifocation,
            [item?.eventKey]: 0,
          };
        });
        let dataTempValue = { ...value };
        if (value?.timeUpload) {
          dataTempValue.timeUpload =
            value?.timeUpload?.map((item) => ({
              fromTime:
                moment(item?.rangeTime?.[0]).hour() * 60 +
                moment(item?.rangeTime?.[0]).minute(),
              toTime:
                moment(item?.rangeTime?.[1]).hour() * 60 +
                moment(item?.rangeTime?.[1]).minute(),
            })) || [];
        }
        let data = {
          perNamespace: JSON.stringify({
            ...dataTempValue,
            notificationEvent: {
              ...dataNotifocation,
              ...dataSelectNotificationEvent,
            },
          }),
          perDevices: '',
          perAccount: '',
          serviceId: service.id,
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.CONFIGURATION_SERVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        setDataPerNameTemp(value);
        setCheckUpdatePerNamespace(true);
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [
      dispatch,
      namespace,
      service,
      dataSelectNotificationEvent,
      listNotificationService,
    ]
  );

  const onFinishPerDevice = useCallback(
    (value, record) => {
      if (value && service) {
        let dataTempValue = { ...value };
        if (value?.periodRecognition) {
          dataTempValue.periodRecognition =
            value?.periodRecognition?.map((item) => ({
              fromTime:
                moment(item?.rangeTime?.[0]).hour() * 60 +
                moment(item?.rangeTime?.[0]).minute(),
              toTime:
                moment(item?.rangeTime?.[1]).hour() * 60 +
                moment(item?.rangeTime?.[1]).minute(),
            })) || [];
        }
        let data = {
          perNamespace: '',
          perAccount: '',
          perDevices: JSON.stringify([
            {
              configuration: { ...dataTempValue },
              serial: record?.serial,
            },
          ]),
          serviceId: service.id,
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.CONFIGURATION_SERVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        setCheckUpdatePerDevice(true);
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service, setCheckUpdatePerDevice]
  );

  const onFinishPerAccount = useCallback(
    (value, record) => {
      if (value && service) {
        let dataTempValue = { ...value };
        if (value?.periodRecognition) {
          dataTempValue.periodRecognition =
            value?.periodRecognition?.map((item) => ({
              fromTime:
                moment(item?.rangeTime?.[0]).hour() * 60 +
                moment(item?.rangeTime?.[0]).minute(),
              toTime:
                moment(item?.rangeTime?.[1]).hour() * 60 +
                moment(item?.rangeTime?.[1]).minute(),
            })) || [];
        }
        let data = {
          perNamespace: '',
          perDevices: '',
          perAccount: JSON.stringify({
            configuration: { ...dataTempValue },
            accountId: record?.accountId,
          }),
          serviceId: service.id,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.CONFIGURATION_SERVICE,
          requestId: timeRequest,
          body: JSON.stringify(data),
        };
        setCheckUpdatePerAccount(true);
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service, timeRequest, setCheckUpdatePerAccount]
  );

  const onActiveDevice = useCallback(
    (deviceSerial) => {
      if (isAuth && license && service && license.numberActive < license.size) {
        setIsLoadActiveLicense((state) => state.concat(deviceSerial));
        let data = {
          serviceId: service.id,
          deviceSerial,
          licenseCode: license.licenseCode,
          namespace,
          accountId: -1,
        };
        let dataObj = {
          appServiceType: SERVICE.ACTIVE_LICENSE_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, license, namespace, service]
  );

  const onActiveAccount = useCallback(
    (accountId) => {
      if (isAuth && license && service && license.numberActive < license.size) {
        setIsLoadActiveLicenseAccount((state) => state.concat(accountId));
        let data = {
          serviceId: service.id,
          accountId,
          licenseCode: license.licenseCode,
          namespace,
          deviceSerial: '',
        };
        let dataObj = {
          appServiceType: SERVICE.ACTIVE_LICENSE_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, license, namespace, service]
  );

  const onActiveNamespace = useCallback(() => {
    if (isAuth && license && service && license.numberActive < license.size) {
      setIsLoadActiveLicenseNamespace((state) => state.concat(service.id));
      let data = {
        serviceId: service.id,
        accountId: -1,
        licenseCode: license.licenseCode,
        namespace,
        deviceSerial: '',
      };
      let dataObj = {
        appServiceType: SERVICE.ACTIVE_LICENSE_SERVICE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, license, namespace, service]);

  const onDeactivateDevice = useCallback(
    (deviceName, deviceSerial) => {
      if (service) {
        let data = {
          serviceId: service.id,
          accountId: -1,
          deviceSerial,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.CANCEL_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        confirm({
          title: t('Deactivate device') + ` "${deviceName}"?`,
          icon: <ExclamationCircleOutlined />,
          okText: t('Deactivate'),
          onOk() {
            return dispatch(socketEmitEvent(dataObj));
          },
          onCancel() { },
        });
      }
    },
    [dispatch, namespace, service, t]
  );

  const onDeactivateAccount = useCallback(
    (fullname, accountId) => {
      if (service) {
        let data = {
          serviceId: service.id,
          accountId,
          deviceSerial: '',
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.CANCEL_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        confirm({
          title: t('Deactivate account') + ` "${fullname}"?`,
          icon: <ExclamationCircleOutlined />,
          okText: t('Deactivate'),
          onOk() {
            return dispatch(socketEmitEvent(dataObj));
          },
          onCancel() { },
        });
      }
    },
    [dispatch, namespace, service, t]
  );

  const onDeactivateNameSpace = useCallback(() => {
    if (service) {
      let data = {
        serviceId: service.id,
        accountId: -1,
        deviceSerial: '',
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.CANCEL_SERVICE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      confirm({
        title: t('Deactivate Namespace?'),
        icon: <ExclamationCircleOutlined />,
        okText: t('Deactivate'),
        onOk() {
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() { },
      });
    }
  }, [dispatch, namespace, service, t]);

  const singleActiveDevice = (deviceSerial) => {
    confirm({
      title: t('Do you want to activate this device?'),
      onOk() {
        return onActiveDevice(deviceSerial);
      },
      onCancel() { },
    });
  };

  const singleActiveAccount = (accountId) => {
    confirm({
      title: t('Do you want to activate this account?'),
      onOk() {
        return onActiveAccount(accountId);
      },
      onCancel() { },
    });
  };

  const singleActiveNamespace = () => {
    confirm({
      title: t('Do you want to activate this namespace?'),
      onOk() {
        return onActiveNamespace();
      },
      onCancel() { },
    });
  };

  const syncActivateDevice = useCallback(() => {
    confirm({
      title: t('Do you want to activate selected devices?'),
      content: activateChain.map((device) => device.name).join('; '),
      onOk() {
        setSyncLoading(true);
        let chain = activateChain;
        setInterval(() => {
          let device = chain.pop();
          if (device) {
            onActiveDevice(device.serial);
          } else {
            clearInterval(this);
            setSyncLoading(false);
          }
        }, 1500);
      },
      onCancel() { },
    });
  }, [activateChain, onActiveDevice, t]);

  const syncActivateAccount = useCallback(() => {
    confirm({
      title: t('Do you want to activate selected accounts?'),
      content: activateChainAccount
        .map((account) => account.fullname)
        .join('; '),
      onOk() {
        setSyncLoading(true);
        let chain = activateChainAccount;
        setInterval(() => {
          let account = chain.pop();
          if (account) {
            onActiveAccount(account.accountId);
          } else {
            clearInterval(this);
            setSyncLoading(false);
          }
        }, 1500);
      },
      onCancel() { },
    });
  }, [activateChainAccount, onActiveAccount, t]);

  const openApplication = () => {
    console.log("🚀 ~ openApplication ~ service:", service)
    console.log("🚀 ~ openApplication ~ shortTokenData:", shortTokenData)
    if (service && service.applicationUrl) {
      if (
        service.id &&
        LIST_SERVICES_SHOULD_APPEND_SHORT_TOKEN.includes(service.id) &&
        shortTokenData?.shortAccessToken
      ) {
        const link = `${service.applicationUrl}&token=${shortTokenData?.shortAccessToken}`;
        window.open(link);
      } else {
        window.open(service.applicationUrl);
      }
    } else {
      const link = `https://resource-api.beex.vn:8050/application/redirect?token=${shortTokenData?.shortAccessToken}&namespace=${namespace}&serviceId=${service?.id}`
      window.open(link);
    }
  };

  const onSearchDeviceByName = (name) => {
    setDataSearchDeviceByName(name?.trim());
    if (service.activeType?.includes('per_device')) {
      setDevices((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
    }
    if (service.activeType?.includes('per_account')) {
      setAccounts((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
    }
    let data = {
      subName: name?.trim(),
      serviceId: service.id,
      page: 0,
      size: 10,
      timeRequest,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_TARGET_BY_SERVICE_ID,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const onNotificationEvent = (category) => {
    const dataNotification = dataNotificationEvent?.find((item) =>
      category?.split(';')?.find((item1) => item1 === item)
    );
    if (dataNotification) {
      let dataObj = {
        appServiceType: SERVICE.LIST_NOTIFICATION_EVENT,
        requestId: new Date().getTime(),
        body: JSON.stringify({
          namespace,
          notificationVia: dataNotification,
        }),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  const onChangeEventNotification = (value, eventNotification) => {
    setDataSelectNotificationEvent({
      ...dataSelectNotificationEvent,
      [eventNotification?.eventKey]: value?.target?.checked ? 1 : 0,
    });
  };
  return (
    <div className="detail-service-component">
      <div className="title-detail-service-component">
        <span>
          <img
            onClick={() => setType(0)}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            src={left}
            alt="left"
          />
          {service && service.name}
        </span>
        <Button
          type="primary"
          style={{ marginLeft: 'auto' }}
          onClick={() => openApplication()}
          disabled={!service}
        >
          <img style={{ marginRight: '10px' }} src={nextPage} alt="next-page" />
          {t('Open Application')}
        </Button>
      </div>
      <div className="button-tab">
        <div>
          <Button
            type={step === 0 ? 'primary' : 'default'}
            style={{ marginLeft: 'auto', width: '96px' }}
            onClick={() => setStep(0)}
          >
            {t('Overview')}
          </Button>
          <Button
            type={step === 1 ? 'primary' : 'default'}
            style={{ marginLeft: '8px', width: '96px' }}
            onClick={() => setStep(1)}
          >
            {t('Activation')}
          </Button>
          {service?.configurationInput &&
            (JSON.parse(service?.configurationInput)?.perNamespace?.length >
              0 ||
              JSON.parse(service?.configurationInput)?.perAccount?.length > 0 ||
              JSON.parse(service?.configurationInput)?.perDevice?.length >
              0) && (
              <Button
                type={step === 2 ? 'primary' : 'default'}
                style={{ marginLeft: '8px', width: '96px' }}
                onClick={() => {
                  setStep(2);
                  onPerDevices();
                  onNotificationEvent(service?.category);
                }}
              >
                {t('Setting')}
              </Button>
            )}
          {service?.baseUrl && (
            <Button
              type={step === 3 ? 'primary' : 'default'}
              style={{ marginLeft: '8px', width: '96px' }}
              onClick={() => setStep(3)}
            >
              {t('Console')}
            </Button>
          )}
        </div>
        {step === 1 && (
          <Search
            placeholder={t('Search by name')}
            onSearch={onSearchDeviceByName}
            style={{ width: 280 }}
            allowClear
          />
        )}
      </div>
      {step === 0 && (
        <>
          <Row>
            <Col
              span={8}
              className="step-0-col-8"
              style={{ minHeight: '40vh' }}
            >
              <div style={{ padding: '16px', color: '#FFFFFF' }}>
                <ReactMarkdown source={service?.releaseInfo ?? ''} />
              </div>
            </Col>
            <Col span={16} className="step-0-col-16">
              <div style={{ padding: '16px', color: '#FFFFFF' }}>
                <ReactMarkdown source={service?.overview ?? ''} />
              </div>
            </Col>
          </Row>
          <div style={{ width: '100%', textAlign: 'end', marginTop: '16px' }}>
            <Button
              type="primary"
            >
              {t('Đăng ký dùng thử')}
            </Button>
          </div>
        </>
      )}
      {step === 1 && (
        <Row gutter={16} style={{ marginLeft: '0px' }}>
          <Col span={6} className="step-1-col">
            <div className="form-check-code">
              <Form
                form={form}
                layout="inline"
                name="register-service"
                onFinish={(values) => onCheckCode(values.checkCode.trim())}
              >
                <Row style={{ width: '100%' }}>
                  <Col span={18}>
                    <Form.Item
                      style={{ width: '97%' }}
                      name="checkCode"
                      rules={[
                        {
                          required: true,
                          message: t('Please enter the license code!'),
                        },
                        {
                          pattern: regex.isurl,
                          message: t('Please enter the license code!'),
                        },
                        {
                          max: 80,
                          message: t('Please input up to 80 characters!'),
                        },
                      ]}
                    >
                      <Input
                        style={{ width: '100%' }}
                        placeholder="License Code"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item style={{ width: '100%' }}>
                      <Button
                        type="primary"
                        style={{ width: '100%' }}
                        htmlType="submit"
                      >
                        {t('Check')}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              {license && license.licenseCode && (
                <div className="license-info">
                  {t('License')} <span>{license.licenseCode}</span> {t('has')}
                  <span>
                    {` ${license.size - license.numberActive}/${license.size} `}
                  </span>
                  {t('of the remaining activation.')}
                </div>
              )}
              {licenseInfo?.licenseCode && (
                <Table
                  pagination={false}
                  scroll={{ y: 155 }}
                  style={{ border: '1px solid #303030' }}
                  size="small"
                  columns={[
                    {
                      title: t('Create date'),
                      dataIndex: 'startAt',
                      key: 'startAt',
                      align: 'center',
                      render: (time) => moment(time).format('DD/MM/YYYY'),
                    },
                    {
                      title: t('Activated'),
                      dataIndex: 'numberActive',
                      key: 'numberActive',
                      align: 'center',
                      render: (numberActive, row) =>
                        `${numberActive ?? 0}/${licenseInfo.size ?? 0}`,
                    },
                    {
                      title: t('Duration'),
                      dataIndex: 'duration',
                      key: 'duration',
                      align: 'center',
                    },
                  ]}
                  dataSource={licenseInfo ? [licenseInfo] : []}
                />
              )}
            </div>
            <div className="description">
              <span>{t('Description')}: </span>
              {service && service.description}
            </div>
          </Col>
          <Col span={18}>
            {service &&
              (service.activeType?.includes('per_device') ||
                service.activeType?.includes('per_account') ||
                service.activeType?.includes('per_namespace')) ? (
              service.activeType?.includes('per_namespace') ? (
                <Table
                  rowClassName={(record) => !record.enabled && 'disabled-row'}
                  rowSelection={rowSelection}
                  dataSource={dataNamespace?.data ?? []}
                  loading={dataNamespace && dataNamespace.loading}
                  onChange={handleTableChange}
                  columns={[
                    {
                      title: t('Namespace'),
                      dataIndex: 'namespace',
                      key: 'namespace_namespace',
                    },
                    {
                      title: t('State'),
                      key: 'log_action',
                      width: 130,
                      render: (namespace) =>
                        isLoadActiveLicenseNamespace.some(
                          (id) => id === namespace.id
                        ) ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$warning}
                          >
                            {t('Activating')}
                          </Tag>
                        ) : namespace.active ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$online}
                          >
                            {t('Activated')}
                          </Tag>
                        ) : (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$offline}
                          >
                            {t('Not activated')}
                          </Tag>
                        ),
                    },
                    {
                      title: t('Action'),
                      key: 'actions',
                      width: 130,
                      render: (namespace) =>
                        namespace.active ? (
                          <div
                            className="edit-button"
                            onClick={() => onDeactivateNameSpace()}
                          >
                            <Button danger htmlType="submit">
                              {t('Deactivate')}
                            </Button>
                          </div>
                        ) : (
                          <div
                            className="edit-button"
                            onClick={() => singleActiveNamespace()}
                          >
                            <Button
                              loading={isLoadActiveLicenseNamespace.some(
                                (id) => id === namespace.id
                              )}
                              disabled={!license}
                              htmlType="submit"
                            >
                              {t('Activate')}
                            </Button>
                          </div>
                        ),
                    },
                  ]}
                />
              ) : service.activeType?.includes('per_device') ? (
                <Table
                  rowClassName={(record) => !record.enabled && 'disabled-row'}
                  rowSelection={rowSelection}
                  dataSource={
                    devices &&
                    devices.data &&
                    devices.data.map((device, key) => ({
                      ...device,
                      key: device.serial,
                    }))
                  }
                  pagination={devices && devices.pagination}
                  loading={devices && devices.loading}
                  onChange={handleTableChange}
                  columns={[
                    {
                      title: t('Name'),
                      dataIndex: 'name',
                      key: 'name_device',
                      sorter: (a, b) => a.name.localeCompare(b.name),
                    },
                    {
                      title: t('State'),
                      key: 'log_action',
                      width: 130,
                      sorter: (a, b) => {
                        const dataA = isLoadActiveLicense.some(
                          (serial) => serial === a.serial
                        )
                          ? 'Activating'
                          : a.service
                            ? 'Activated'
                            : 'Not activated';
                        const dataB = isLoadActiveLicense.some(
                          (serial) => serial === b.serial
                        )
                          ? 'Activating'
                          : b.service
                            ? 'Activated'
                            : 'Not activated';
                        return dataA.localeCompare(dataB);
                      },
                      render: (device) =>
                        isLoadActiveLicense.some(
                          (serial) => serial === device.serial
                        ) ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$warning}
                          >
                            {t('Activating')}
                          </Tag>
                        ) : device.service ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$online}
                          >
                            {t('Activated')}
                          </Tag>
                        ) : (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$offline}
                          >
                            {t('Not activated')}
                          </Tag>
                        ),
                    },
                    {
                      title: t('Active date'),
                      key: 'log_activatedAt',
                      dataIndex: 'service',
                      sorter: (a, b) =>
                        a.service?.activatedAt?.localeCompare(
                          b.service?.activatedAt
                        ),
                      render: (service) =>
                        service?.activatedAt
                          ? moment(service.activatedAt).format('DD-MM-YYYY')
                          : '',
                    },
                    {
                      title: t('License Code'),
                      key: 'service_license_code_device',
                      dataIndex: 'service',
                      render: (service) =>
                        service?.licenseCode ? service?.licenseCode : '',
                    },
                    {
                      title: t('License Info'),
                      key: 'service_license_info_device',
                      dataIndex: 'service',
                      render: (service) =>
                        service?.licenseInfo ? service?.licenseInfo : '',
                    },
                    {
                      title: t('Action'),
                      key: 'actions',
                      width: 130,
                      render: (device) =>
                        device.service ? (
                          <div
                            className="edit-button"
                            onClick={() =>
                              onDeactivateDevice(device.name, device.serial)
                            }
                          >
                            <Button danger htmlType="submit">
                              {t('Deactivate')}
                            </Button>
                          </div>
                        ) : (
                          <div
                            className="edit-button"
                            onClick={() => singleActiveDevice(device.serial)}
                          >
                            <Button
                              loading={isLoadActiveLicense.some(
                                (serial) => serial === device.serial
                              )}
                              disabled={!license}
                              htmlType="submit"
                            >
                              {t('Activate')}
                            </Button>
                          </div>
                        ),
                    },
                  ]}
                  footer={() => (
                    <div className="sync-activates">
                      <Button
                        loading={syncLoading}
                        onClick={() => syncActivateDevice()}
                        type="primary"
                        disabled={
                          !license ||
                          activateChain.length === 0 ||
                          isLoadActiveLicense.length > 0 ||
                          activateChain.length >
                          license.size - license.numberActive
                        }
                      >
                        {t('Sync activates')} ({activateChain.length})
                      </Button>
                    </div>
                  )}
                />
              ) : (
                <Table
                  rowClassName={(record) => !record.enabled && 'disabled-row'}
                  rowSelection={rowSelectionAccount}
                  dataSource={
                    accounts &&
                    accounts.data &&
                    accounts.data.map((device, key) => ({
                      ...device,
                      key: device.accountId,
                    }))
                  }
                  pagination={accounts && accounts.pagination}
                  loading={accounts && accounts.loading}
                  onChange={handleTableChange}
                  columns={[
                    {
                      title: t('Full name'),
                      dataIndex: 'fullname',
                      key: 'fullname_account',
                      sorter: (a, b) =>
                        (a.fullname ?? '').localeCompare(b.fullname ?? ''),
                    },
                    {
                      title: t('Name'),
                      dataIndex: 'username',
                      key: 'username_account',
                      sorter: (a, b) =>
                        (a.username ?? '').localeCompare(b.username ?? ''),
                    },
                    {
                      title: t('State'),
                      key: 'log_action',
                      width: 130,
                      sorter: (a, b) => {
                        const dataA = isLoadActiveLicenseAccount.some(
                          (id) => id === a.accountId
                        )
                          ? 'Activating'
                          : a.service
                            ? 'Activated'
                            : 'Not activated';
                        const dataB = isLoadActiveLicenseAccount.some(
                          (id) => id === b.accountId
                        )
                          ? 'Activating'
                          : b.service
                            ? 'Activated'
                            : 'Not activated';
                        return dataA.localeCompare(dataB);
                      },
                      render: (account) =>
                        isLoadActiveLicenseAccount.some(
                          (id) => id === account.accountId
                        ) ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$warning}
                          >
                            {t('Activating')}
                          </Tag>
                        ) : account.service ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$online}
                          >
                            {t('Activated')}
                          </Tag>
                        ) : (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$offline}
                          >
                            {t('Not activated')}
                          </Tag>
                        ),
                    },
                    {
                      title: t('Active date'),
                      key: 'log_activatedAt',
                      dataIndex: 'service',
                      sorter: (a, b) =>
                        a.service?.activatedAt?.localeCompare(
                          b.service?.activatedAt
                        ),
                      render: (service) =>
                        service?.activatedAt
                          ? moment(service.activatedAt).format('DD-MM-YYYY')
                          : '',
                    },
                    {
                      title: t('Action'),
                      key: 'actions',
                      width: 130,
                      render: (account) =>
                        account.service ? (
                          <div
                            className="edit-button"
                            onClick={() =>
                              onDeactivateAccount(
                                account.fullname,
                                account.accountId
                              )
                            }
                          >
                            <Button danger htmlType="submit">
                              {t('Deactivate')}
                            </Button>
                          </div>
                        ) : (
                          <div
                            className="edit-button"
                            onClick={() =>
                              singleActiveAccount(account.accountId)
                            }
                          >
                            <Button
                              loading={isLoadActiveLicenseAccount.some(
                                (id) => id === account.accountId
                              )}
                              disabled={!license}
                              htmlType="submit"
                            >
                              {t('Activate')}
                            </Button>
                          </div>
                        ),
                    },
                  ]}
                  footer={() => (
                    <div className="sync-activates">
                      <Button
                        loading={syncLoading}
                        onClick={() => syncActivateAccount()}
                        type="primary"
                        disabled={
                          !license ||
                          activateChainAccount.length === 0 ||
                          isLoadActiveLicenseAccount.length > 0 ||
                          activateChainAccount.length >
                          license.size - license.numberActive
                        }
                      >
                        {t('Sync activates')} ({activateChainAccount.length})
                      </Button>
                    </div>
                  )}
                />
              )
            ) : (
              <Result
                status={service && service.state === 'on' ? 'success' : 'info'}
                title={
                  service && service.state === 'on'
                    ? t('The service has been activated!')
                    : t('Service activation required!')
                }
                subTitle={t('_START_AT_START_END', {
                  startAt: service && service.startAt,
                })}
                extra={[
                  <Button disabled={!license} type="primary" key="activate">
                    {t('Activate the service')}
                  </Button>,
                ]}
              />
            )}
          </Col>
        </Row>
      )}
      {step === 2 && (
        <Row gutter={16} style={{ marginLeft: '0px' }}>
          {service?.configurationInput &&
            JSON.parse(service?.configurationInput)?.perNamespace?.length >
            0 && (
              <Col
                className="step-1-col"
                span={
                  JSON.parse(service?.configurationInput)?.perNamespace
                    ?.length > 0 &&
                    JSON.parse(service?.configurationInput)?.perAccount?.length >
                    0
                    ? 24
                    : 8
                }
                style={{
                  marginBottom:
                    JSON.parse(service?.configurationInput)?.perNamespace
                      ?.length > 0 &&
                      JSON.parse(service?.configurationInput)?.perAccount
                        ?.length > 0
                      ? '8px'
                      : '0px',
                }}
              >
                <Form
                  form={form}
                  style={{ paddingTop: '16px' }}
                  name="register-service"
                  layout="vertical"
                  onFinish={onFinishPerNamespace}
                  initialValues={
                    service?.configuration ?? initialPerNameSpace ?? {}
                  }
                >
                  <Row style={{ width: '100%' }}>
                    {JSON.parse(service?.configurationInput)?.perNamespace?.map(
                      (item, index) => (
                        <FormCustom
                          key={index}
                          spanLayout={
                            JSON.parse(service?.configurationInput)
                              ?.perNamespace?.length > 0 &&
                              JSON.parse(service?.configurationInput)?.perAccount
                                ?.length > 0
                              ? 8
                              : 24
                          }
                          data={item}
                          dataSerial={service}
                          disabled={checkUpdatePerNamespace}
                        />
                      )
                    )}
                    {!!listNotificationService?.eventInfos?.length &&
                      JSON.parse(
                        service?.configurationInput
                      )?.perNamespace?.find(
                        (item) => item.field === 'notificationEvent'
                      ) && (
                        <Col span={24}>
                          <Form.Item
                            style={{ width: '100%' }}
                            label={
                              JSON.parse(
                                service?.configurationInput
                              )?.perNamespace?.find(
                                (item) => item.field === 'notificationEvent'
                              )?.fieldDisplay ?? t('Event notification')
                            }
                          >
                            {listNotificationService?.eventInfos?.map(
                              (item) => (
                                <Checkbox
                                  key={item.eventKey}
                                  checked={
                                    !!dataSelectNotificationEvent?.[
                                    item.eventKey
                                    ]
                                  }
                                  onChange={(value) =>
                                    onChangeEventNotification(value, item)
                                  }
                                  style={{ marginLeft: '8px' }}
                                  disabled={checkUpdatePerNamespace}
                                >
                                  {item.message}
                                </Checkbox>
                              )
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    <Col span={24}>
                      <Form.Item style={{ width: '100%', textAlign: 'center' }}>
                        <Button
                          disabled={checkUpdatePerNamespace}
                          type="primary"
                          htmlType="submit"
                        >
                          {t('Update')}
                        </Button>
                        {/* )} */}
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <img
                  onClick={() => {
                    setCheckUpdatePerNamespace(
                      checkUpdatePerNamespace ? false : true
                    );
                    if (!checkUpdatePerNamespace) {
                      form.setFieldsValue(dataPerNameTemp);
                    }
                  }}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    cursor: 'pointer',
                  }}
                  src={checkUpdatePerNamespace ? iconEdit : iconEditActive}
                  alt="next-page"
                />
              </Col>
            )}
          {service?.configurationInput &&
            JSON.parse(service?.configurationInput)?.perDevice?.length > 0 && (
              <Col span={16}>
                <Table
                  key={keyTable}
                  dataSource={
                    devicesActive &&
                    devicesActive.data &&
                    devicesActive.data.map((device, key) => ({
                      ...device,
                      key: device.serial,
                    }))
                  }
                  expandable={{
                    expandedRowRender: (record) => (
                      <Form
                        form={formExpand}
                        name="register-service"
                        layout="vertical"
                        onFinish={(value) => onFinishPerDevice(value, record)}
                        initialValues={
                          (record?.service?.configuration &&
                            JSON.parse(record?.service?.configuration)) ??
                          initialPerDevice ??
                          {}
                        }
                      >
                        {service?.configurationInput &&
                          JSON.parse(service?.configurationInput)?.perDevice
                            ?.length > 0 && (
                            <Row gutter={32} style={{ width: '100%' }}>
                              {JSON.parse(
                                service?.configurationInput
                              )?.perDevice?.map((item, index) => (
                                <FormCustom
                                  key={index}
                                  spanLayout={
                                    item?.type === 'period-minute' ? 10 : 12
                                  }
                                  data={item}
                                  dataSerial={record}
                                  formExpand={formExpand}
                                  disabled={checkUpdatePerDevice}
                                />
                              ))}
                              <Col span={24}>
                                {/* {checkUpdatePerDevice && ( */}
                                <Form.Item
                                  style={{
                                    width: '100%',
                                  }}
                                >
                                  <Button
                                    disabled={checkUpdatePerDevice}
                                    type="primary"
                                    htmlType="submit"
                                  >
                                    {t('Update')}
                                  </Button>
                                  <Popconfirm
                                    placement="top"
                                    title={t('Are you sure？')}
                                    okText={t('Yes')}
                                    onConfirm={() => {
                                      setKeyTable(Math.random());
                                      const dataConfigurationTemp =
                                        record?.service?.configuration &&
                                        JSON.parse(
                                          record?.service?.configuration
                                        );
                                      formExpand.setFieldsValue(
                                        Object.keys(dataConfigurationTemp)
                                          .length > 0
                                          ? dataConfigurationTemp
                                          : initialPerDevice ?? {}
                                      );
                                    }}
                                    cancelText={t('No')}
                                  >
                                    <Button
                                      disabled={checkUpdatePerDevice}
                                      style={{ marginLeft: '10px' }}
                                    >
                                      {t('Restore')}
                                    </Button>
                                  </Popconfirm>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                      </Form>
                    ),
                  }}
                  expandedRowKeys={expKeys}
                  onExpand={(check, record) => {
                    setExpKeys(check ? [record?.serial] : []);
                    setKeyTable(Math.random());
                    setCheckUpdatePerDevice(true);
                    const dataConfigurationTemp =
                      record?.service?.configuration &&
                      JSON.parse(record?.service?.configuration);
                    formExpand.setFieldsValue(
                      Object.keys(dataConfigurationTemp).length > 0
                        ? dataConfigurationTemp
                        : initialPerDevice ?? {}
                    );
                  }}
                  pagination={devicesActive && devicesActive.pagination}
                  loading={devicesActive && devicesActive.loading}
                  onChange={handleTableChangeActive}
                  columns={[
                    {
                      title: t('Name'),
                      dataIndex: 'name',
                      key: 'name_device',
                      sorter: (a, b) => a.name.localeCompare(b.name),
                    },
                    {
                      title: t('State'),
                      key: 'log_action',
                      width: 200,
                      render: (device) =>
                        isLoadActiveLicense.some(
                          (serial) => serial === device.serial
                        ) ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$warning}
                          >
                            {t('Activating')}
                          </Tag>
                        ) : device.service ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$online}
                          >
                            {t('Activated')}
                          </Tag>
                        ) : (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$offline}
                          >
                            {t('Not activated')}
                          </Tag>
                        ),
                    },
                    {
                      title: t('Active date'),
                      key: 'log_activatedAt',
                      dataIndex: 'service',
                      sorter: (a, b) =>
                        a.service?.activatedAt?.localeCompare(
                          b.service?.activatedAt
                        ),
                      render: (service) =>
                        service?.activatedAt
                          ? moment(service.activatedAt).format('DD-MM-YYYY')
                          : '',
                    },
                    {
                      title: t('License Code'),
                      key: 'service_license_code_device',
                      dataIndex: 'service',
                      render: (service) =>
                        service?.licenseCode ? service?.licenseCode : '',
                    },
                    {
                      title: t('License Info'),
                      key: 'service_license_info_device',
                      dataIndex: 'service',
                      render: (service) =>
                        service?.licenseInfo ? service?.licenseInfo : '',
                    },
                    {
                      title: t('Action'),
                      key: 'actions ',
                      render: (record) => (
                        <div className="manager-member-actions">
                          <div
                            className="edit-button"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setExpKeys([record?.serial]);
                              setKeyTable(Math.random());
                              setCheckUpdatePerDevice(false);
                              const dataConfigurationTemp =
                                record?.service?.configuration &&
                                JSON.parse(record?.service?.configuration);
                              formExpand.setFieldsValue(
                                Object.keys(dataConfigurationTemp).length > 0
                                  ? dataConfigurationTemp
                                  : initialPerDevice ?? {}
                              );
                            }}
                          >
                            <EditOutlined /> {t('Edit')}
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </Col>
            )}
          {service?.configurationInput &&
            JSON.parse(service?.configurationInput)?.perAccount?.length > 0 && (
              <Col span={16}>
                <Table
                  key={keyTable}
                  dataSource={
                    accountsActive &&
                    accountsActive.data &&
                    accountsActive.data.map((device, key) => ({
                      ...device,
                      key: device.accountId,
                    }))
                  }
                  expandable={{
                    expandedRowRender: (record) => (
                      <Form
                        form={formExpandAccount}
                        name="register-service"
                        layout="vertical"
                        onFinish={(value) => onFinishPerAccount(value, record)}
                        initialValues={
                          (record?.service?.configuration &&
                            JSON.parse(record?.service?.configuration)) ??
                          initialPerAccount ??
                          {}
                        }
                      >
                        {service?.configurationInput &&
                          JSON.parse(service?.configurationInput)?.perAccount
                            ?.length > 0 && (
                            <Row gutter={32} style={{ width: '100%' }}>
                              {JSON.parse(
                                service?.configurationInput
                              )?.perAccount?.map((item, index) => (
                                <FormCustom
                                  key={index}
                                  spanLayout={
                                    item?.type === 'period-minute' ? 10 : 12
                                  }
                                  data={item}
                                  dataSerial={record}
                                  formExpand={formExpandAccount}
                                  disabled={checkUpdatePerAccount}
                                />
                              ))}
                              <Col span={24}>
                                {/* {checkUpdatePerDevice && ( */}
                                <Form.Item
                                  style={{
                                    width: '100%',
                                  }}
                                >
                                  <Button
                                    disabled={checkUpdatePerAccount}
                                    type="primary"
                                    htmlType="submit"
                                  >
                                    {t('Update')}
                                  </Button>
                                  <Popconfirm
                                    placement="top"
                                    title={t('Are you sure？')}
                                    okText={t('Yes')}
                                    onConfirm={() => {
                                      setKeyTable(Math.random());
                                      const dataConfigurationTemp =
                                        record?.service?.configuration &&
                                        JSON.parse(
                                          record?.service?.configuration
                                        );
                                      formExpandAccount.setFieldsValue(
                                        Object.keys(dataConfigurationTemp)
                                          .length > 0
                                          ? dataConfigurationTemp
                                          : initialPerAccount ?? {}
                                      );
                                    }}
                                    cancelText={t('No')}
                                  >
                                    <Button
                                      disabled={checkUpdatePerAccount}
                                      style={{ marginLeft: '10px' }}
                                    >
                                      {t('Restore')}
                                    </Button>
                                  </Popconfirm>
                                </Form.Item>
                                {/* )} */}
                              </Col>
                            </Row>
                          )}
                      </Form>
                    ),
                  }}
                  expandedRowKeys={expKeysAccount}
                  onExpand={(check, record) => {
                    setExpKeysAccount(check ? [record?.accountId] : []);
                    setKeyTable(Math.random());
                    setCheckUpdatePerAccount(true);
                    const dataConfigurationTemp =
                      record?.service?.configuration &&
                      JSON.parse(record?.service?.configuration);
                    formExpandAccount.setFieldsValue(
                      Object.keys(dataConfigurationTemp).length > 0
                        ? dataConfigurationTemp
                        : initialPerAccount ?? {}
                    );
                  }}
                  pagination={accountsActive && accountsActive.pagination}
                  loading={accountsActive && accountsActive.loading}
                  onChange={handleTableChangeAccountActive}
                  columns={[
                    {
                      title: t('Full name'),
                      dataIndex: 'fullName',
                      key: 'fullname_account',
                      sorter: (a, b) =>
                        (a.fullName ?? '').localeCompare(b.fullName ?? ''),
                    },
                    {
                      title: t('Name'),
                      dataIndex: 'userName',
                      key: 'username_account',
                      sorter: (a, b) =>
                        (a.userName ?? '').localeCompare(b.userName ?? ''),
                    },
                    {
                      title: t('State'),
                      key: 'log_action',
                      width: 200,
                      render: (account) =>
                        isLoadActiveLicenseAccount.some(
                          (id) => id === account.accountId
                        ) ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$warning}
                          >
                            {t('Activating')}
                          </Tag>
                        ) : account.service ? (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$online}
                          >
                            {t('Activated')}
                          </Tag>
                        ) : (
                          <Tag
                            style={{ width: 120, textAlign: 'center' }}
                            color={colorsDark.$offline}
                          >
                            {t('Not activated')}
                          </Tag>
                        ),
                    },
                    {
                      title: t('Active date'),
                      key: 'log_activatedAt',
                      dataIndex: 'service',
                      sorter: (a, b) =>
                        a.service?.activatedAt?.localeCompare(
                          b.service?.activatedAt
                        ),
                      render: (service) =>
                        service?.activatedAt
                          ? moment(service.activatedAt).format('DD-MM-YYYY')
                          : '',
                    },
                    {
                      title: t('License Code'),
                      key: 'service_license_code_device',
                      dataIndex: 'service',
                      render: (service) =>
                        service?.licenseCode ? service?.licenseCode : '',
                    },
                    {
                      title: t('License Info'),
                      key: 'service_license_info_device',
                      dataIndex: 'service',
                      render: (service) =>
                        service?.licenseInfo ? service?.licenseInfo : '',
                    },
                    {
                      title: t('Action'),
                      key: 'actions ',
                      render: (record) => (
                        <div className="manager-member-actions">
                          <div
                            className="edit-button"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setExpKeysAccount([record?.accountId]);
                              setKeyTable(Math.random());
                              setCheckUpdatePerAccount(false);
                              const dataConfigurationTemp =
                                record?.service?.configuration &&
                                JSON.parse(record?.service?.configuration);
                              formExpandAccount.setFieldsValue(
                                Object.keys(dataConfigurationTemp).length > 0
                                  ? dataConfigurationTemp
                                  : initialPerAccount ?? {}
                              );
                            }}
                          >
                            <EditOutlined /> {t('Edit')}
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </Col>
            )}
        </Row>
      )}
      {step === 3 && (
        <Row style={{ marginLeft: '0px' }}>
          <Col span={24}>
            <Table
              key={keyTable}
              dataSource={
                devicesActive &&
                devicesActive.data &&
                devicesActive.data.map((device, key) => ({
                  ...device,
                  key: device.serial,
                }))
              }
              expandable={{
                expandedRowRender: (record) => (
                  <LogEventServiceCamera
                    dataDevice={record}
                    baseUrl={service?.baseUrl}
                    serviceId={service.id}
                  />
                ),
              }}
              expandedRowKeys={expKeys}
              onExpand={(check, record) => {
                setExpKeys(check ? [record?.serial] : []);
                setKeyTable(Math.random());
                setCheckUpdatePerDevice(true);
                const dataConfigurationTemp =
                  record?.service?.configuration &&
                  JSON.parse(record?.service?.configuration);
                formExpand.setFieldsValue(
                  Object.keys(dataConfigurationTemp).length > 0
                    ? dataConfigurationTemp
                    : initialPerDevice ?? {}
                );
              }}
              pagination={devicesActive && devicesActive.pagination}
              loading={devicesActive && devicesActive.loading}
              onChange={handleTableChangeActive}
              columns={[
                {
                  title: t('Name'),
                  dataIndex: 'name',
                  key: 'name_device',
                  sorter: (a, b) => a.name.localeCompare(b.name),
                },
                {
                  title: t('State'),
                  key: 'log_action',
                  width: 200,
                  render: (device) =>
                    isLoadActiveLicense.some(
                      (serial) => serial === device.serial
                    ) ? (
                      <Tag
                        style={{ width: 120, textAlign: 'center' }}
                        color={colorsDark.$warning}
                      >
                        {t('Activating')}
                      </Tag>
                    ) : device.service ? (
                      <Tag
                        style={{ width: 120, textAlign: 'center' }}
                        color={colorsDark.$online}
                      >
                        {t('Activated')}
                      </Tag>
                    ) : (
                      <Tag
                        style={{ width: 120, textAlign: 'center' }}
                        color={colorsDark.$offline}
                      >
                        {t('Not activated')}
                      </Tag>
                    ),
                },
                {
                  title: t('Active date'),
                  key: 'log_activatedAt',
                  dataIndex: 'service',
                  sorter: (a, b) =>
                    a.service?.activatedAt?.localeCompare(
                      b.service?.activatedAt
                    ),
                  render: (service) =>
                    service?.activatedAt
                      ? moment(service.activatedAt).format('DD-MM-YYYY')
                      : '',
                },
                {
                  title: t('License Code'),
                  key: 'service_license_code_device',
                  dataIndex: 'service',
                  render: (service) =>
                    service?.licenseCode ? service?.licenseCode : '',
                },
                {
                  title: t('License Info'),
                  key: 'service_license_info_device',
                  dataIndex: 'service',
                  render: (service) =>
                    service?.licenseInfo ? service?.licenseInfo : '',
                },
              ]}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default DetailServiceComponent;
